<script setup lang="ts"></script>

<template>
  <div class="spinners">
    <div class="spinner-inner">
      <div class="spinner-border w-auto h-auto border-0">
        <app-public-image alt="loader" class="loader" src="images/loader.svg" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.spinners {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;

  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner-inner {
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
}
</style>
